import React from "react";
import Button, { ButtonThemes } from "../../../ui-components/button/button";
import Tooltip from "./Tooltip";

interface DashboardCardProps {
  icon: React.ReactNode;
  title: string;
  totalValue: number | string;
  totalLabel: string;
  metrics: Array<{
    label: string;
    value: number | string;
  }>;
  onShowMore?: () => void;
  info?: string[];
}

const DashboardCard: React.FC<DashboardCardProps> = ({ 
  icon, 
  title, 
  totalValue, 
  totalLabel, 
  metrics, 
  onShowMore,
  info
}) => {
  return (
    <div className="dashboard-card">
      <div className="dashboard-card__header">
        <div className="dashboard-card__icon">
          {icon}
        </div>
        <div className="dashboard-card__header-content">
          <span className="dashboard-card__total-label">{title}</span>
          <span className="dashboard-card__total-value">{totalValue} {totalLabel}</span>
        </div>
        {info && <Tooltip tooltips={info} />}
      </div>
      <div className="dashboard-card__metrics">
        {metrics.map((metric, index) => (
          <div key={index} className="dashboard-card__metric">
            <span className="dashboard-card__metric-label">{metric.label}:</span>
            <span className="dashboard-card__metric-value">{metric.value}</span>
          </div>
        ))}
      </div>
      {!!onShowMore && (
        <div className="dashboard-card__footer">
          <Button 
            theme={ButtonThemes.transparent} 
            className="dashboard-card__show-more"
            onClick={onShowMore}
          >
            Show more ↗
          </Button>
        </div>
      )}
    </div>
  );
};

export default DashboardCard;
